module.exports = __webpack_public_path__ + "media/images/off-sale-0c8e49f3238f1a1380c1465554b44661.png";